import { render, staticRenderFns } from "./ExtraInputsModal.vue?vue&type=template&id=2ec5b942&scoped=true&"
import script from "./ExtraInputsModal.vue?vue&type=script&lang=js&"
export * from "./ExtraInputsModal.vue?vue&type=script&lang=js&"
import style0 from "./ExtraInputsModal.vue?vue&type=style&index=0&id=2ec5b942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec5b942",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ec5b942')) {
      api.createRecord('2ec5b942', component.options)
    } else {
      api.reload('2ec5b942', component.options)
    }
    module.hot.accept("./ExtraInputsModal.vue?vue&type=template&id=2ec5b942&scoped=true&", function () {
      api.rerender('2ec5b942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/Extras/ExtraInputsModal.vue"
export default component.exports